import { observer } from 'mobx-react';
import { UserProductLicenseResource } from '../../../../../ParticipantsStore/Types';
import AuditorStatus from './AuditorStatus';
import ExpireOn from './ExpireOn';
import LicenseImage from './LicenseImage';
import LicenseStatus from './LicenseStatus';
import StartOn from './StartOn';

interface Props {
  license: UserProductLicenseResource;
}

function LicenseDetails({ license }: Props) {
  return (
    <div className="flex gap-3">
      <LicenseImage license={license} />
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-3">
          <span className="font-medium">{license.payload.name}</span>
          <LicenseStatus license={license} />
          <AuditorStatus license={license} />
        </div>
        <div className="flex divide-x divide-solid divide-black">
          <span className="pr-1">
            <StartOn date={license.payload.startOn} />
          </span>
          <span className="pl-1">
            <ExpireOn date={license.payload.endOn} />
          </span>
        </div>
      </div>
    </div>
  );
}

export default observer(LicenseDetails);
